
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Editable from '@/mixins/Editable';
import VWrapper from '@/components/shared/VWrapper.vue';
import { namespace } from 'vuex-class';
import Notification from '@/mixins/Notification';
import RoleForm from '../../components/role/RoleForm.vue';
import { Role } from '@/interfaces/models/Role';
import EditRoleLoader from '@/components/role/EditRoleLoader.vue';
import StackedForm from '@/mixins/StackedForm';
import { cloneDeep } from '@/util/helper';

const role = namespace('role');

@Component({
  components: { EditRoleLoader, RoleForm, VWrapper },
})
export default class EditRole extends mixins(Editable, Notification, StackedForm) {
  @role.Action('store') public store!: any;
  @role.Action('show') public show!: any;
  @role.Action('update') public update!: any;
  @role.Mutation('clearCopy') public clearCopy!: any;
  @role.State('active') public active!: Role;
  @role.State('copiedRole') public copiedRole!: Role;

  public $refs!: {
    form: InstanceType<typeof RoleForm> & { getData: () => any; validate: () => Promise<boolean | boolean[]> };
  };

  public role: Role | null = null;

  get title() {
    return this.editing ? 'role.edit' : 'role.create';
  }

  public async mounted() {
    if (this.editing) {
      this.$startLoading('role');
      await this.show({ id: this.id });

      if (this.active) {
        this.role = this.active;
      }
    }

    if (this.editing && !this.active) {
      this.$router.push({ name: 'role.index', query: { ...this.$route.query } });
    }

    if (!this.editing && this.copiedRole) {
      this.role = cloneDeep(this.copiedRole);
    }

    this.$stopLoading('role');

    this.$nextTick(() => {
      this.clearCopiedRole();
    });
  }

  public save() {
    this.$refs.form.validate().then(async (res: boolean | boolean[]) => {
      if (this.isValid(res)) {
        if (this.editing) {
          await this.update({ ...this.$refs.form.getData(), id: this.active!._id });
        } else {
          await this.store({ ...this.$refs.form.getData() });
        }
        this.$router.push({ name: 'role.index', query: { ...this.$route.query } });
      } else {
        this.notifyError('notification.form');
      }
    });
  }

  public clearCopiedRole() {
    if (this.editing || !this.copiedRole) {
      return;
    }

    this.clearCopy();
  }

  public beforeDestroy() {
    this.clearCopiedRole();
  }
}
